import request from '@/utils/request';

// 获取验证码
export function getCode() {
  return request({
    url: '/CarlcareManager/authority/get-verification-code',
    method: 'post'
  });
}
export function login(data) {
  return request({
    url: '/CarlcareManager/authority/login',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/CarlcareManager/authority/logout',
    method: 'post'
  });
}